export default "__VITE_ASSET__a4469a46__"